<script lang="ts" setup>
import TagItem from '@/common/components/molecules/tag/TagItem.vue';
</script>

<template>
  <div class="time-policy">
    <v-stack>
      <div class="time-policy--title">
        {{ $t('MESSAGE.TIME_PERIOD_POLICY.TITLE') }}
      </div>
      <Separator class="time-policy--separator" />
      <v-stack class="time-policy--description">
        <div>
          <tag-item size="xsmall">from time</tag-item>
          {{ $t('MESSAGE.TIME_PERIOD_POLICY.FROM_TIME_DESCRIPTION') }}
        </div>
        <br />
        <div>
          <tag-item size="xsmall">to time</tag-item>
          {{ $t('MESSAGE.TIME_PERIOD_POLICY.TO_TIME_DESCRIPTION') }}
        </div>
      </v-stack>
    </v-stack>
  </div>
</template>

<style scoped lang="scss">
.time-policy {
  display: none;
  position: absolute;
  z-index: $on-popup;
  width: fit-content;
  height: 94px;
  background-color: var(--color-gray-08-00);
  box-shadow: var(--chart-tooltip-box-shadow);
  &--title {
    padding: 6px 10px;
    color: var(--main-font-color);

    @include typography('sub-title-3');
  }
  &--separator {
    width: 100%;
    height: 1px;
    background-color: var(--color-gray-05-05);
  }
  &--description {
    padding: 10px 12px;
    color: var(--color-gray-02-10);

    @include typography('body-3');
  }
}
</style>
